webpackJsonp([1],{

/***/ "+IK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return coloris; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return groups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return chants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return services; });
/* eslint-disable */
var coloris = [{ "group": 4, "name": "Abalone", "id": 0 }, { "group": 4, "name": "Antartica", "id": 1 }, { "group": 2, "name": "Aqua", "id": 2 }, { "group": 4, "name": "Arctic Ice", "id": 3 }, { "group": 4, "name": "Arrowroot", "id": 4 }, { "group": 2, "name": "Aurora", "id": 5 }, { "group": 4, "name": "Aztec Gold", "id": 6 }, { "group": 4, "name": "Beige Fieldstone", "id": 7 }, { "group": 1, "name": "Bisque", "id": 8 }, { "group": 1, "name": "Bone", "id": 9 }, { "group": 4, "name": "Burled Beach", "id": 10 }, { "group": 1, "name": "Cameo White", "id": 11 }, { "group": 3, "name": "Canyon", "id": 12 }, { "group": 4, "name": "Clam Shell", "id": 13 }, { "group": 2, "name": "Clay", "id": 14 }, { "group": 3, "name": "Deep Bedrock", "id": 15 }, { "group": 3, "name": "Deep Black Quartz", "id": 16 }, { "group": 3, "name": "Deep Night Sky", "id": 17 }, { "group": 1, "name": "Designer White", "id": 18 }, { "group": 2, "name": "Diamond Blue", "id": 19 }, { "group": 2, "name": "Dove", "id": 20 }, { "group": 4, "name": "Dune Prima", "id": 21 }, { "group": 2, "name": "Dusk", "id": 22 }, { "group": 2, "name": "Eclipse", "id": 23 }, { "group": 4, "name": "Ecru", "id": 24 }, { "group": 1, "name": "Elegant Gray", "id": 25 }, { "group": 3, "name": "Everest", "id": 26 }, { "group": 4, "name": "Fossil", "id": 27 }, { "group": 0, "name": "Glacier White", "id": 28 }, { "group": 4, "name": "Gray Onyx", "id": 29 }, { "group": 4, "name": "Graylite", "id": 30 }, { "group": 4, "name": "Hazelnut", "id": 31 }, { "group": 2, "name": "Imperial Yellow", "id": 32 }, { "group": 4, "name": "Juniper", "id": 33 }, { "group": 4, "name": "Lava Rock", "id": 34 }, { "group": 1, "name": "Light Ash", "id": 35 }, { "group": 4, "name": "Limestone Prima", "id": 36 }, { "group": 2, "name": "Linen", "id": 37 }, { "group": 3, "name": "Matterhorn", "id": 38 }, { "group": 2, "name": "Midnight", "id": 39 }, { "group": 3, "name": "Neutral Concrete", "id": 40 }, { "group": 4, "name": "Nimbus Prima", "id": 41 }, { "group": 1, "name": "Pearl Gray", "id": 42 }, { "group": 4, "name": "Platinum", "id": 43 }, { "group": 2, "name": "Raffia", "id": 44 }, { "group": 4, "name": "Raincloud", "id": 45 }, { "group": 4, "name": "Rosemary", "id": 46 }, { "group": 4, "name": "Sagebrush", "id": 47 }, { "group": 4, "name": "Sahara", "id": 48 }, { "group": 2, "name": "Sand", "id": 49 }, { "group": 4, "name": "Sandalwood", "id": 50 }, { "group": 2, "name": "Sandstone", "id": 51 }, { "group": 4, "name": "Savannah", "id": 52 }, { "group": 1, "name": "Seagrass", "id": 53 }, { "group": 2, "name": "Silt", "id": 54 }, { "group": 4, "name": "Silver Birch", "id": 55 }, { "group": 1, "name": "Silver Gray", "id": 56 }, { "group": 4, "name": "Sonora", "id": 57 }, { "group": 2, "name": "Sparkling White", "id": 58 }, { "group": 4, "name": "Tumbleweed", "id": 59 }, { "group": 1, "name": "Vanilla", "id": 60 }, { "group": 2, "name": "Venaro White", "id": 61 }, { "group": 2, "name": "Warm Grey", "id": 62 }, { "group": 2, "name": "White Jasmine", "id": 63 }, { "group": 4, "name": "White Onyx", "id": 64 }, { "group": 4, "name": "Whitecap", "id": 65 }, { "group": 3, "name": "Willow", "id": 66 }, { "group": 4, "name": "Witch Hazel", "id": 67 }];

var groups = {
  0: { credence: 0.000380, chant: 60 },
  1: { credence: 0.000400, chant: 65 },
  2: { credence: 0.000460, chant: 80 },
  3: { credence: 0.000480, chant: 80 },
  4: { credence: 0.000520, chant: 80 }
};

var chants = [{ "name": "Chant poli sur plan de 12mm", id: 0, price: 0.024 }, { "name": "Chant standard sur plan de 24mm à 50mm", id: 1, price: 0.042 }];

var options = [{ id: 0, name: "Découpe brute", price: 60, image: "http://www.easyplandetravail.com/img-bordure/decoupe-brute-pour-plaque-de-cuisson.jpg" }, { id: 1, name: "Découpe polie", price: 105, image: "http://www.easyplandetravail.com/img-bordure/decoupe-polie-pour-cuve-par-dessous.jpg" }, { id: 2, name: "Découpe plaque de cuisson", price: 95, image: "http://www.easyplandetravail.com/img-bordure/decoupe-brute-pour-plaque-de-cuisson.jpg" }, { id: 3, name: "Égouttoir en pente", price: 225, image: "http://www.easyplandetravail.com/img-bordure/decoupe-polie-pour-cuve-sous-plan-avec-egouttoir-decaisse.jpg" }, { id: 4, name: "Percement brut pour prise électrique", price: 15, image: "http://www.easyplandetravail.com/img-bordure/percement-brut-pour-prise-electrique.jpg" }, { id: 5, name: "Percement brut pour robinetterie et vidage", price: 15, image: "http://www.easyplandetravail.com/img-bordure/percement-brut-pour-robinetterie-et-vidage.jpg" }, { id: 6, name: "Rainurages en pente", price: 120, image: "http://www.easyplandetravail.com/img-bordure/rainurage-incline-dans-la-masse.jpg" }, { id: 7, name: "Repose plat rainurage avec 4 barres inox", price: 140, image: "http://www.easyplandetravail.com/img-bordure/repose-plat-rainurage-4-barres.jpg" }];

var services = [{ id: 0, name: "Prise de gabarit à domicile Proliner", price: 230 }, { id: 1, name: "Emballage et transport Paris et RP", price: 190, necessary: true }, { id: 2, name: "Pose standard et déplacement >= 6 m²", price: 540 }, { id: 3, name: "Supplément pose dosseret ou crédence >= 3m²", price: 130 }, { id: 4, name: "Supplément livraison par élévateur", price: 340 }, { id: 5, name: "Dépose et enlèvement de plan existant", price: 150 }, { id: 6, name: "Installation crédence verre si deuxième passage", price: 320 }, { id: 7, name: "Raccordement 1 évier + 1 cuisson standard sauf gaz", price: 190 }];



/***/ }),

/***/ "+pFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__ = __webpack_require__("+IK/");
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      chants: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["d" /* chants */],
      chant: 0,
      price: 0,
      longueur: null
    };
  },

  watch: {
    // longueur () {
    //   this.setPrice()
    // }
  },
  methods: {
    setPrice: function setPrice() {
      var p = this.longueur * this.chants[this.chant].price;
      if (this.price !== p) {
        this.$store.commit('subPrice', this.price);
        this.$store.commit('addPrice', p);
        this.price = p;
        this.setDevis();
      }
    },
    setDevis: function setDevis() {
      this.$store.commit('setDevis', { id: 2, set: { longueur: this.longueur, chant: this.chant } });
    }
  }
});

/***/ }),

/***/ "/Hhd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"devis"},[_c('div',{staticClass:"devis-background",style:(("background:url(/static/images/dupont_corian_" + (_vm.color.src) + ".jpg)"))}),_vm._v(" "),_c('div',{staticClass:"devis-parts"},[_c('p',{staticClass:"info"},[_vm._v("\n    Estimez en direct le prix de votre projet cuisine ou salle de bains, grâce à notre outil de simulation. Remplissez les champs suivants. Validez. Nous calculons le coût de votre plan de travail en temps réel.\n  ")]),_vm._v(" "),_c('div',{staticClass:"part",attrs:{"id":"materiaux"}},[_c('h1',[_vm._v("Votre matériau")]),_vm._v(" "),_c('Coloris',{on:{"changeColor":function($event){_vm.changeColor($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"part",attrs:{"id":"taille-plan"}},[_c('h1',[_vm._v("Votre plan de travail en mm (épaisseur 12mm)")]),_vm._v(" "),_c('TaillePlan',{attrs:{"group":_vm.$store.state.devis[0].group}})],1),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"part",attrs:{"id":"epaisseur-chant"}},[_c('h1',[_vm._v("Épaisseur et longueur du chant en mm")]),_vm._v(" "),_c('FormeBordure',{attrs:{"longueur":_vm.$store.state.devis[1].longueur}})],1),_vm._v(" "),_c('div',{staticClass:"part",attrs:{"id":"taille-credence"}},[_c('h1',[_vm._v("Crédence en mm (épaisseur 12mm)")]),_vm._v(" "),_c('TailleCredence',{attrs:{"group":_vm.$store.state.devis[0].group}})],1),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"part",attrs:{"id":"options"}},[_c('h1',{staticClass:"blue"},[_vm._v("Options et découpe")]),_vm._v(" "),_c('Options')],1),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"part",attrs:{"id":"services"}},[_c('h1',{staticClass:"blue"},[_vm._v("Services")]),_vm._v(" "),_c('Services')],1),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"part",attrs:{"id":""}},[_c('h1',{staticClass:"blue"},[_vm._v("T.V.A. réduite (10%)")]),_vm._v(" "),_c('div',{staticClass:"service"},[_c('Tva')],1)]),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('div',{staticClass:"part"},[_c('h1',{staticClass:"blue",staticStyle:{"margin-bottom":"15px"}},[_vm._v("Vos coordonnées")]),_vm._v(" "),_c('Coordonnees')],1)]),_vm._v(" "),_c('div',{staticClass:"devis-fixed"},[_c('Price'),_vm._v(" "),_c('div',{staticClass:"part"}),_vm._v(" "),(!_vm.done && !_vm.loading)?_c('button',{staticClass:"download",on:{"click":function($event){_vm.download()}}},[_vm._v("Télécharger votre devis")]):_vm._e(),_vm._v(" "),(!_vm.done && _vm.loading)?_c('button',{staticClass:"download"},[_c('i',{staticClass:"fa fa-circle-o-notch"}),_vm._v("Veuillez patienter...")]):_vm._e(),_vm._v(" "),(_vm.done && !_vm.loading)?_c('button',{staticClass:"download"},[_c('i',{staticClass:"fa fa-check",staticStyle:{"margin-right":"10px"}}),_vm._v("Merci de vérifier votre boite mail")]):_vm._e()],1),_vm._v(" "),_c('Foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/R/G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"/static/logo.svg"}})]),_vm._v(" "),_c('div',{staticClass:"menu-wrapper"},[_c('router-link',{staticClass:"menu",class:{'menu-active': (_vm.selected==='Accueil')},attrs:{"to":"/"}},[_c('div',{staticClass:"menu_element"},[_c('i',{staticClass:"fa fa-home"})]),_vm._v(" "),_c('h1',{staticClass:"libelle_menu"},[_vm._v("Accueil")])]),_vm._v(" "),_c('router-link',{staticClass:"menu",class:{'menu-active': (_vm.selected==='Devis')},staticStyle:{"font-size":"32px"},attrs:{"to":"/devis"}},[_c('div',{staticClass:"menu_element"},[_c('i',{staticClass:"fa fa-calculator"})]),_vm._v(" "),_c('h1',{staticClass:"libelle_menu"},[_vm._v("Votre devis")])]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menu",staticStyle:{"font-size":"28px"},attrs:{"href":"mailto:contact@plantravail.fr"}},[_c('div',{staticClass:"menu_element"},[_c('i',{staticClass:"fa fa-envelope"})]),_vm._v(" "),_c('h1',{staticClass:"libelle_menu"},[_vm._v("Contactez-nous")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot-logo"},[_c('img',{attrs:{"src":"/static/dupont.png"}}),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"width":"75px"},attrs:{"src":"/static/quality_network_new.jpg"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Hq0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Bpe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__ = __webpack_require__("+IK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_digitsonly_js__ = __webpack_require__("p72H");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_digitsonly_js__["a" /* JustDigits */])();

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['group'],
  data: function data() {
    return {
      epaisseur: 13,
      longueur: null,
      largeur: null,
      price: 0,
      curGroup: 4,
      groups: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["b" /* groups */],
      plans: []
    };
  },

  watch: {
    group: function group() {
      if (this.$store.state.devis[0].group !== this.curGroup) {
        this.setPrice();
        this.curGroup = this.$store.state.devis[0].group;
      }
    }
  },
  methods: {
    addPlan: function addPlan() {
      if (this.longueur != null && this.largeur != null && !isNaN(this.longueur) && !isNaN(this.largeur)) {
        var p = this.longueur * this.largeur * this.groups[this.$store.state.devis[0].group].credence;
        this.plans.push({ lng: this.longueur, lrg: this.largeur, price: p, beautifulPrice: this.beautify(p) });
        this.longueur = null;
        this.largeur = null;
        this.$store.commit('addPrice', p);
        this.setDevis();
      }
    },
    removePlan: function removePlan(_index) {
      this.$store.commit('subPrice', this.plans[_index].price);
      this.plans.splice(_index, 1);
      this.setDevis();
    },
    setDevis: function setDevis() {
      this.$store.commit('setDynamicDevis', { id: 6, set: { plans: this.plans } });
    },
    beautify: function beautify(price) {
      return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  }
});

/***/ }),

/***/ "2jhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Price_vue__ = __webpack_require__("P/Vp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd4a833e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Price_vue__ = __webpack_require__("J0Vb");
function injectStyle (ssrContext) {
  __webpack_require__("Au/I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd4a833e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Price_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd4a833e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Price_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3zhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    setTva: function setTva(e) {
      if (e.target.checked) {
        this.$store.commit('applyTva', 10);
      } else {
        this.$store.commit('applyTva', 20);
      }
    }
  }
});

/***/ }),

/***/ "4r/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{staticClass:"coloris",attrs:{"value":"Abalone"},on:{"change":function($event){_vm.setColoris($event)}}},_vm._l((_vm.coloris),function(c){return _c('option',{domProps:{"value":c.name}},[_vm._v("Corian "+_vm._s(c.name)+" ("+_vm._s(c.group)+")")])})),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.finition),expression:"finition"}],staticClass:"coloris",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.finition=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.setDevis()}]}},[_c('option',{attrs:{"value":"mat"}},[_vm._v("Mat")]),_vm._v(" "),_c('option',{attrs:{"value":"satine"}},[_vm._v("Satiné")])]),_vm._v(" "),_c('div',{staticClass:"color-name"},[_vm._v("\n    "+_vm._s(_vm.curColoris)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5iRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__ = __webpack_require__("+IK/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      show: false,
      showId: 0,
      options: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["a" /* options */],
      prices: [{ id: 0, price: 0, quantity: 0 }, { id: 1, price: 0, quantity: 0 }, { id: 2, price: 0, quantity: 0 }, { id: 3, price: 0, quantity: 0 }, { id: 4, price: 0, quantity: 0 }, { id: 5, price: 0, quantity: 0 }, { id: 6, price: 0, quantity: 0 }, { id: 7, price: 0, quantity: 0 }]
    };
  },

  methods: {
    showImage: function showImage(id) {
      this.show = true;
      this.showId = id;
    },
    hideImage: function hideImage(id) {
      this.show = false;
    },
    setPrice: function setPrice(id, e) {
      var p = this.options[id].price * parseInt(e.target.value);
      if (this.prices[id].price !== p) {
        this.$store.commit('subPrice', this.prices[id].price);
        this.$store.commit('addPrice', p);
        this.prices[id].price = p;
        this.prices[id].quantity = parseInt(e.target.value);
      }
      this.setDevis();
    },
    setDevis: function setDevis() {
      this.$store.commit('setDevis', { id: 4, set: { options: this.prices } });
    }
  }
});

/***/ }),

/***/ "9DYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pdfLink: this.$store.state.pdfLink
    };
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      if (_this.$store.state.pdfLink !== _this.pdfLink) {
        console.log(_this.$store.state.pdfLink);
      }
    }, 250);
  }
});

/***/ }),

/***/ "Au/I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BxJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tva_wrap"},[_c('div',{staticClass:"tva"},[_vm._v("\n    T.V.A. 10% applicable aux logements à usage d'habitation de plus de 2 ans si l'installation est réalisée par nos soins."),_vm._v(" "),_c('label',[_c('input',{staticClass:"ios-switch",attrs:{"type":"checkbox"},on:{"change":function($event){_vm.setTva($event)}}}),_vm._m(0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CFT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch"}),_c('br'),_c('br'),_vm._v("\n  Votre devis est en cours de préparation...\n")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EykM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormeBordure_vue__ = __webpack_require__("+pFA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b804c00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FormeBordure_vue__ = __webpack_require__("WQJo");
function injectStyle (ssrContext) {
  __webpack_require__("QQlk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b804c00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormeBordure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b804c00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_FormeBordure_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HGB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"services"},_vm._l((_vm.services),function(s){return _c('div',{staticClass:"service"},[_vm._v("\n    "+_vm._s(s.name)+" ("+_vm._s(s.price)+"€)"),_vm._v(" "),_c('label',[_c('input',{staticClass:"ios-switch",attrs:{"type":"checkbox"},on:{"change":function($event){_vm.setPrice(s.id, $event)}}}),_vm._m(0,true)])])}))}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    pdfLink: '',
    price: 0,
    tva: 20,
    beautifulPrice: '',
    beautifulTva: '',
    beautifulPriceTTC: '',
    devis: [{ id: 0, coloris: 'Abalone', finition: 'mat', group: 4, price: 0 }, { id: 1, longueur: null, largeur: null, epaisseur: 0, price: 0 }, { id: 2, longueur: 0, chant: 0, price: 0 }, { id: 3, longueur: 0, largeur: 0, epaisseur: 0, price: 0 }, { id: 4,
      options: [{ id: 0, quantity: 0, price: 0 }, { id: 1, quantity: 0, price: 0 }, { id: 2, quantity: 0, price: 0 }, { id: 3, quantity: 0, price: 0 }, { id: 4, quantity: 0, price: 0 }, { id: 5, quantity: 0, price: 0 }, { id: 6, quantity: 0, price: 0 }, { id: 7, quantity: 0, price: 0 }]
    }, { id: 5,
      services: [{ id: 0, selected: 0, price: 0 }, { id: 1, selected: 0, price: 0 }, { id: 2, selected: 0, price: 0 }, { id: 3, selected: 0, price: 0 }, { id: 4, selected: 0, price: 0 }, { id: 5, selected: 0, price: 0 }, { id: 6, selected: 0, price: 0 }, { id: 7, selected: 0, price: 0 }]
    }, { id: 6,
      plans: []
    }, { id: 7,
      credences: []
    }],
    user: {
      name: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      zip: '',
      questions: ''
    }
  },
  mutations: {
    subPrice: function subPrice(state, val) {
      state.price -= val;
    },
    addPrice: function addPrice(state, val) {
      state.price += val;
    },
    applyTva: function applyTva(state, val) {
      state.tva = val;
    },
    setDynamicDevis: function setDynamicDevis(state, params) {
      state.devis[params.id] = params.set;
    },
    setDevis: function setDevis(state, params) {
      var s = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params.set);
      for (var i = 0; i < s.length; i++) {
        state.devis[params.id][s[i]] = params.set[s[i]];
      }
    },
    setDevisPrice: function setDevisPrice(state, params) {
      state.devis[params.id].price = params.price;
    },
    setDevisMultiplePrice: function setDevisMultiplePrice(state, params) {
      for (var i = 0; i < state.devis[params.id][params.subid].length; i++) {
        state.devis[params.id][params.subid][i].price = params.price[i];
      }
    },
    setDevisInfo: function setDevisInfo(state, params) {
      state.devis[params.id][params.subid] = params.val;
    },
    setBeautifulPrice: function setBeautifulPrice(state, price) {
      state.beautifulPrice = price;
    },
    setDevisMultipleInfo: function setDevisMultipleInfo(state, params) {
      for (var i = 0; i < state.devis[params.id][params.subid].length; i++) {
        state.devis[params.id][params.subid][i].name = params.val[i];
      }
    },
    setPDFLink: function setPDFLink(state, pdfLink) {
      state.pdfLink = pdfLink;
    },
    setUserInfos: function setUserInfos(state, params) {
      state.user[params.id] = params.value;
    },
    setBeautifulTvaTtc: function setBeautifulTvaTtc(state) {
      state.beautifulTva = parseFloat(state.price * state.tva / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      state.beautifulPriceTTC = parseFloat(state.price + state.price * state.tva / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  }
}));

/***/ }),

/***/ "IfG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('input',{directives:[{name:"digitsonly",rawName:"v-digitsonly"},{name:"model",rawName:"v-model",value:(_vm.longueur),expression:"longueur"}],attrs:{"type":"text","placeholder":"Longueur du plan de travail (en mm)"},domProps:{"value":(_vm.longueur)},on:{"change":_vm.addPlan,"input":function($event){if($event.target.composing){ return; }_vm.longueur=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"digitsonly",rawName:"v-digitsonly"},{name:"model",rawName:"v-model",value:(_vm.largeur),expression:"largeur"}],attrs:{"type":"text","placeholder":"Largeur du plan de travail (en mm)"},domProps:{"value":(_vm.largeur)},on:{"change":_vm.addPlan,"input":function($event){if($event.target.composing){ return; }_vm.largeur=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.plans),function(p,index){return _c('div',{attrs:{"id":"liste_plan"}},[_c('div',{staticClass:"plan_valeur plan_mesure"},[_vm._v("\n         "+_vm._s(p.lng)+" mm x "+_vm._s(p.lrg)+" mm x 12mm\n      ")]),_vm._v(" "),_c('div',{staticClass:"plan_valeur plan_prix"},[_vm._v("\n         "+_vm._s(p.beautifulPrice)+"€\n      ")]),_vm._v(" "),_c('div',{staticClass:"plan_valeur plan_remove"},[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){_vm.removePlan(index)}}})])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IrMI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J0Vb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed"},[_c('h2',[_vm._v("Estimation de votre projet")]),_vm._v(" "),_c('div',{staticClass:"recap"},[_c('router-link',{attrs:{"to":"#materiaux"}},[_vm._v("Matériau")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$store.state.devis[0].coloris)+" "+_vm._s((_vm.$store.state.devis[0].finition == 'mat')?'mat':'satiné')+" ("+_vm._s(_vm.$store.state.devis[0].group)+")")])],1),_vm._v(" "),_c('div',{staticClass:"recap"},[_c('router-link',{attrs:{"to":"#taille-plan"}},[_vm._v("Taille de votre plan")]),_vm._v(" "),_vm._l((_vm.$store.state.devis[6].plans),function(p,index){return _c('div',{staticClass:"flex-element"},[_vm._v("\n         "+_vm._s(p.lng)+" mm x "+_vm._s(p.lrg)+" mm x 12mm\n         "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(p.beautifulPrice)+"€")])])})],2),_vm._v(" "),_c('div',{staticClass:"recap"},[_c('router-link',{attrs:{"to":"#epaisseur-chant"}},[_vm._v("Épaisseur du chant")]),_vm._v(" "),_c('div',{staticClass:"flex-element"},[_vm._v("\n      "+_vm._s(_vm.$store.state.devis[2].longueur)+"mm "+_vm._s(_vm.chants[_vm.$store.state.devis[2].chant].name)+"\n      "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.beautify(_vm.$store.state.devis[2].longueur * _vm.chants[_vm.$store.state.devis[2].chant].price))+" €")])])],1),_vm._v(" "),_c('div',{staticClass:"recap"},[_c('router-link',{attrs:{"to":"#taille-credence"}},[_vm._v("Taille de votre crédence")]),_vm._v(" "),_vm._l((_vm.$store.state.devis[7].credences),function(c,index){return _c('div',{staticClass:"flex-element"},[_vm._v("\n         "+_vm._s(c.lng)+" mm x "+_vm._s(c.lrg)+" mm x 12mm\n         "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(c.beautifulPrice)+"€")])])})],2),_vm._v(" "),_c('div',{staticClass:"recap"},[_c('router-link',{attrs:{"to":"#options"}},[_vm._v("Options et découpe")]),_vm._v(" "),_vm._l((_vm.$store.state.devis[4].options),function(o){return (o.quantity > 0)?_c('div',{staticClass:"flex-element"},[_vm._v("\n        "+_vm._s(o.quantity)+"x "+_vm._s(_vm.options[o.id].name)+"\n        "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.beautify(_vm.options[o.id].price * o.quantity))+" €")])]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"recap"},[_c('router-link',{attrs:{"to":"#services"}},[_vm._v("Services")]),_vm._v(" "),_vm._l((_vm.$store.state.devis[5].services),function(s){return (s.selected)?_c('div',{staticClass:"flex-element"},[_vm._v("\n        "+_vm._s(_vm.services[s.id].name)+"\n        "),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm.beautify(_vm.services[s.id].price))+" €")])]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"total"},[_c('div',{staticClass:"total_ht"},[_c('b',[_vm._v("TOTAL HT")]),_vm._v("\n       "+_vm._s(_vm.beautify(_vm.$store.state.price))+" €\n    ")]),_vm._v(" "),_c('div',{staticClass:"tva"},[_c('b',[_vm._v("TVA "+_vm._s(_vm.$store.state.tva)+"%")]),_vm._v("\n       "+_vm._s(_vm.beautify( _vm.$store.state.price * _vm.$store.state.tva / 100 ))+" €\n    ")]),_vm._v(" "),_c('div',{staticClass:"total_ttc"},[_c('b',[_vm._v("TOTAL TTC")]),_vm._v("\n       "+_vm._s(_vm.beautify( _vm.$store.state.price + (_vm.$store.state.price * _vm.$store.state.tva / 100) ))+" €\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JAuM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JOvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TailleCredence_vue__ = __webpack_require__("yUn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cc0eecc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TailleCredence_vue__ = __webpack_require__("afvx");
function injectStyle (ssrContext) {
  __webpack_require__("0Hq0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9cc0eecc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TailleCredence_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cc0eecc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TailleCredence_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KnNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-head"},[_c('b',[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("Plantravail.fr powered by IPA SARL - 54, rue Perthuis 92140 Clamart - Tél. : 01 46 31 63 80")]),_vm._v(" - Design & Développement : "),_c('a',{attrs:{"href":"mailto:bonjour@charlemagneagency.com"}},[_vm._v("agence Charlemagne")]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("Visitez également : "),_c('a',{attrs:{"href":"http://www.ipa-paris.fr/","target":"_blank"}},[_vm._v("ipa-paris.fr")]),_vm._v(" et "),_c('a',{attrs:{"href":"http://adaptive-paris.com/","target":"_blank"}},[_vm._v("adaptive-paris.com")])])]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/static/logo.svg"}})]),_vm._v("\n    Corian® Glacier White Corian® Antarctica Corian® Arctic Ice Corian® Venaro White Corian® White Jasmine Corian® Glacier Ice Corian® Cameo White Corian® Seafoam Corian® Witch Hazel Corian® Bisque Corian® Rice Paper Corian® Linen Corian® Vanilla Corian® Abalone Corian® Whipped Cream Corian® Savannah Corian® Pearl Gray Corian® Bone Corian® Whisper Corian® Clam Shell Corian® Sandalwood Corian® Tumbleweed Corian® Cottage Lane Corian® Aurora Corian® Canvas Corian® Ecru Corian® Fossil Corian® Sahara Corian® Saffron Corian® Hickory Smoke Corian® Aztec Gold Corian® Mojave Corian® Burled Beach Corian® Granola Corian® Raffia Corian® Sand Storm Corian® Sand Corian® Absolute Beige Corian® Oat Corian® Sandstone Corian® Hazelnut Corian\n® Matterhorn Corian® Doeskin Corian® Desert Corian® Fawn Corian® Riverbed Corian® Sonora Corian® Suede Corian® Maui Corian® Basil Corian® Thyme Corian® Royal Red Corian® Allspice Corian® Deep Bedrock  Corian® Cocoa Brown Corian® Canyon Corian® Bronzite Corian® Deep Espresso Corian® Sorrel Corian® Earth Corian® Willow Corian® Sagebrush Corian® Concrete Corian® Jasmine Corian® Noble Ecru Corian® Mint Ice Corian® Cilantro Corian® Dove Corian® Aqualite Corian® Pine Corian® Serene Sage Corian® Rosemary Corian® Moss Corian® Silt Corian® Silver Birch Corian® Arrowroot Corian® Rain Cloud Corian® Juniper Corian® Blue Pebble Corian® Stardust Corian® Mineral Corian® Moonlit Sea Corian® Blue Spice Corian® Elderberry Corian® Cobalt Corian® Silverite Corian® Platinum Corian® Natural Gray Corian® Silver Gray Corian® Elegant Gray Corian® Graylite Corian® Deep Mink Corian® Deep Sable Corian® Milky Way Corian® Lava Rock Corian® Flint Corian® Anthracite Corian® Deep Caviar Corian® Deep Storm Corian® Deep Space Corian® Deep Black Quartz Corian® Deep Night Sky Corian® Deep Nocturne Corian® Deep Anthracite Corian® Deep Cloud Corian® Deep Inkwell Corian® Deep Lapis Corian® Deep Smoky Pearl Corian® Deep Terrain Corian® Deep Titanium Corian® Modern White Corian® Nightfall\n  "),_c('a',{staticClass:"question",attrs:{"href":"mailto:contact@plantravail.fr","id":"btn_question"}},[_vm._v("\n    Une question ?\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LM2C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Sidebar'),_vm._v(" "),_c('router-view',{staticClass:"content"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54205c91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("LM2C");
function injectStyle (ssrContext) {
  __webpack_require__("eNBg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54205c91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+D9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasMoreQuestions: false
    };
  },

  methods: {
    set: function set(id, e) {
      this.$store.commit('setUserInfos', { id: id, value: e.target.value });
    },
    limit: function limit(e) {
      if (e.keyCode === 8) {
        if (e.target.value.length < 200) {
          this.hasMoreQuestions = false;
        }
        return;
      }
      if (e.target.value.length >= 200) {
        this.hasMoreQuestions = true;
      }
      if (e.target.value.length >= 250) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (e.target.value.length < 200) {
        this.hasMoreQuestions = false;
      }
    }
  }
});

/***/ }),

/***/ "NAvN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NLsD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NaON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__ = __webpack_require__("+IK/");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      services: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["c" /* services */],
      prices: [{ id: 0, selected: 0 }, { id: 1, selected: 0 }, { id: 2, selected: 0 }, { id: 3, selected: 0 }, { id: 4, selected: 0 }, { id: 5, selected: 0 }, { id: 6, selected: 0 }, { id: 7, selected: 0 }]
    };
  },

  methods: {
    setPrice: function setPrice(id, e) {
      var p = parseInt(this.services[id].price);
      if (e.target.checked) {
        this.prices[id].selected = 1;
        this.$store.commit('addPrice', p);
      } else {
        this.prices[id].selected = 0;
        this.$store.commit('subPrice', p);
      }
      this.setDevis();
    },
    setDevis: function setDevis() {
      this.$store.commit('setDevis', { id: 5, set: { services: this.prices } });
    }
  }
});

/***/ }),

/***/ "OHZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__("NaON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7ea4614_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__("HGB7");
function injectStyle (ssrContext) {
  __webpack_require__("PX4K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c7ea4614"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7ea4614_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P/Vp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__ = __webpack_require__("+IK/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["a" /* options */],
      groups: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["b" /* groups */],
      services: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["c" /* services */],
      chants: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["d" /* chants */],
      showOptions: false,
      showServices: false
    };
  },

  methods: {
    beautify: function beautify(price) {
      return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  }
});

/***/ }),

/***/ "PEh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tva_vue__ = __webpack_require__("3zhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31cb9792_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tva_vue__ = __webpack_require__("BxJX");
function injectStyle (ssrContext) {
  __webpack_require__("x6Y0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31cb9792"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tva_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31cb9792_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Tva_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PX4K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QQlk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RJfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coordonnees_vue__ = __webpack_require__("N+D9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1907d351_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Coordonnees_vue__ = __webpack_require__("iBW6");
function injectStyle (ssrContext) {
  __webpack_require__("pYxc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1907d351"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coordonnees_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1907d351_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Coordonnees_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WQJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.longueur),expression:"longueur"}],attrs:{"type":"text","placeholder":"Longueur du chant (en mm)"},domProps:{"value":(_vm.longueur)},on:{"change":function($event){_vm.setPrice()},"input":function($event){if($event.target.composing){ return; }_vm.longueur=$event.target.value}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.chant),expression:"chant"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.chant=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.setPrice()}]}},_vm._l((_vm.chants),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Devis__ = __webpack_require__("m1tP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello__ = __webpack_require__("qSdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pdf__ = __webpack_require__("rEkn");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Accueil',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Hello__["a" /* default */]
  }, {
    path: '/devis',
    name: 'Devis',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Devis__["a" /* default */]
  }, {
    path: '/pdf',
    name: 'PDF',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pdf__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zxut":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a8/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"hello-wrapper"},[_vm._m(0),_vm._v(" "),_c('slider',{staticStyle:{"flex-grow":"1","height":"auto"},attrs:{"animation":"normal","auto":true,"indicators":false,"control-btn":true}},_vm._l((_vm.backgrounds),function(i,index){return _c('slider-item',{key:index},[_c('div',{staticClass:"background-slide",style:(i)})])}))],1),_vm._v(" "),_c('Foot')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-left"},[_c('div',{staticClass:"blue"},[_c('h1',[_vm._v("BIENVENUE CHEZ I.P.A.")]),_vm._v(" "),_c('h2',[_vm._v("leader du PLAN DE TRAVAIL\nen corian®")]),_vm._v(" "),_c('p',[_vm._v("\nLa société I P A est le leader français spécialisé dans la transformation de DuPont™ Corian (marque leader de résine acrylique) et la réalisation de mobilier sur-mesure design pour de grands donneurs d'ordre, des professionnels et des particuliers.\n")]),_vm._v(" "),_c('p',[_vm._v("\nAvec plus de 12 années d’expérience dans la transformation des \"solid surfaces\", IPA bénéficie de la certification « Transformateur Agréé Corian® » et vous propose des prestations de qualité en matière d'aménagement intérieur entre autres :\n")]),_vm._v(" "),_c('p',[_vm._v("\ndans l'habitat (cuisines, salles de bains, habillages muraux, objets design…)\ndans le tertiaire (sanitaires PMR, banques d’accueil…)\nainsi que dans l’univers de la santé (cabinets dentaires, hôpitaux…)\nNotre force, c'est une équipe d’artisans menuisiers maîtrisant parfaitement la transformation de DuPont™ Corian® (matériau de revêtement homogène, massif, non poreux, réparable et thermo formable) ainsi qu’un atelier situé à 4 km de Paris et équipé des toutes dernières technologies nécessaires à la transformation en petites et grandes séries de cette résine de acrylique.\n")]),_vm._v(" "),_c('p',[_vm._v("\nI P A assure un suivi de vos projets de A à Z avec un seul interlocuteur. Toutes nos créations sont à 100% des fabrications françaises !\n")]),_vm._v(" "),_c('p',[_vm._v("\nLes professionnels de chez IPA se déplacent rapidement sur l’ensemble de l’Ile-de-France ainsi que sur la France entière pour étudier votre projet et pour vous apporter les réponses et les solutions techniques adéquates.\n")]),_vm._v(" "),_c('p',[_vm._v("\nAprès réception du projet ou visite sur site, nous vous soumettrons dans les plus brefs délais un devis gratuit, personnalisé et détaillé.\n")]),_vm._v(" "),_c('p',[_vm._v("\nQuel que soit votre projet Corian®, n’hésitez pas à nous consulter… vous avez la garantie d’une excellente qualité puisque nous faisons partie du réseau Corian® et nous sommes enregistrés sous Numéro Quality Network 1106.\n")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "afvx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('input',{directives:[{name:"digitsonly",rawName:"v-digitsonly"},{name:"model",rawName:"v-model",value:(_vm.longueur),expression:"longueur"}],attrs:{"type":"text","placeholder":"Longueur de la crédence (en mm)"},domProps:{"value":(_vm.longueur)},on:{"change":_vm.addCredence,"input":function($event){if($event.target.composing){ return; }_vm.longueur=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"digitsonly",rawName:"v-digitsonly"},{name:"model",rawName:"v-model",value:(_vm.largeur),expression:"largeur"}],attrs:{"type":"text","placeholder":"Largeur de la crédence (en mm)"},domProps:{"value":(_vm.largeur)},on:{"change":_vm.addCredence,"input":function($event){if($event.target.composing){ return; }_vm.largeur=$event.target.value}}})]),_vm._v(" "),_vm._l((_vm.credences),function(c,index){return _c('div',{attrs:{"id":"liste_credence"}},[_c('div',{staticClass:"credence_valeur credence_mesure"},[_vm._v("\n          "+_vm._s(c.lng)+" mm x "+_vm._s(c.lrg)+" mm x 12mm\n       ")]),_vm._v(" "),_c('div',{staticClass:"credence_valeur credence_prix"},[_vm._v("\n          "+_vm._s(c.beautifulPrice)+"€\n       ")]),_vm._v(" "),_c('div',{staticClass:"credence_valeur credence_remove"},[_c('i',{staticClass:"fa fa-trash",on:{"click":function($event){_vm.removeCredence(index)}}})])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b5JR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__ = __webpack_require__("+IK/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      curColoris: 'Abalone',
      curGroup: 4,
      coloris: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["e" /* coloris */],
      finition: 'mat',
      price: 0,
      groups: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["b" /* groups */]
    };
  },

  methods: {
    setColoris: function setColoris(e) {
      var _this = this;

      var newSrc = e.target.value.toLowerCase();
      newSrc = newSrc.replace(/ /g, '_');
      this.$emit('changeColor', { src: newSrc, name: e.target.value });
      this.curColoris = e.target.value;
      var colObj = this.coloris.find(function (el) {
        return el.name === _this.curColoris;
      });
      this.curGroup = colObj.group;
      this.setDevis();
    },
    setDevis: function setDevis() {
      this.$store.commit('setDevis', { id: 0, set: { coloris: this.curColoris, finition: this.finition, group: this.curGroup } });
    }
  }
});

/***/ }),

/***/ "eNBg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f3NK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected: 'Accueil'
    };
  },
  mounted: function mounted() {
    this.selected = this.$route.name;
  },

  watch: {
    $route: function $route() {
      this.selected = this.$route.name;
    }
  }
});

/***/ }),

/***/ "hbzW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hlmL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Options_vue__ = __webpack_require__("5iRY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4f2136_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Options_vue__ = __webpack_require__("kDKF");
function injectStyle (ssrContext) {
  __webpack_require__("JAuM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c4f2136"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Options_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4f2136_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Options_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iBW6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"type":"text","placeholder":"Nom"},on:{"change":function($event){_vm.set('name', $event)}}}),_vm._v(" "),_c('input',{attrs:{"type":"email","placeholder":"Email"},on:{"change":function($event){_vm.set('email', $event)}}}),_vm._v(" "),_c('input',{attrs:{"type":"phone","placeholder":"Téléphone"},on:{"change":function($event){_vm.set('phone', $event)}}}),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"Adresse"},on:{"change":function($event){_vm.set('address', $event)}}}),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"Ville"},on:{"change":function($event){_vm.set('city', $event)}}}),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"Code Postal"},on:{"change":function($event){_vm.set('zip', $event)}}}),_vm._v(" "),(_vm.hasMoreQuestions)?_c('div',{staticClass:"hasMoreQuestions"},[_vm._v("\n    Si vous avez plus de questions, merci de nous contacter au "),_c('a',{attrs:{"href":"tel:0146316380"}},[_vm._v("01 46 31 63 80")]),_vm._v(" ou par mail via "),_c('a',{attrs:{"href":"mailto:contact@plantravail.fr"}},[_vm._v("contact@plantravail.fr")]),_vm._v(".\n  ")]):_vm._e(),_vm._v(" "),_c('textarea',{attrs:{"placeholder":"Vos questions"},on:{"change":function($event){_vm.set('questions', $event)},"keydown":function($event){_vm.limit($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jNot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kDKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options"},_vm._l((_vm.options),function(o){return _c('div',{staticClass:"option",on:{"mouseenter":function($event){_vm.showImage(o.id)},"mouseleave":function($event){_vm.hideImage()}}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show && _vm.showId === o.id)?_c('div',{staticClass:"option-image"},[_c('img',{attrs:{"src":o.image}})]):_vm._e()]),_vm._v("\n    "+_vm._s(o.name)+" ("+_vm._s(o.price)+"€)\n    "),_c('select',{staticClass:"options_options",on:{"change":function($event){_vm.setPrice(o.id, $event)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("0")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5")])])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lZ5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("f3NK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e7b6e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("/R/G");
function injectStyle (ssrContext) {
  __webpack_require__("xh7a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70e7b6e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e7b6e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m1tP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devis_vue__ = __webpack_require__("qrrU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a071c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Devis_vue__ = __webpack_require__("/Hhd");
function injectStyle (ssrContext) {
  __webpack_require__("jNot")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05a071c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05a071c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Devis_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ml20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coloris_vue__ = __webpack_require__("b5JR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec94a36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Coloris_vue__ = __webpack_require__("4r/n");
function injectStyle (ssrContext) {
  __webpack_require__("hbzW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Coloris_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec94a36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Coloris_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nq5D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__ = __webpack_require__("t2Vd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4916cf77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__ = __webpack_require__("KnNV");
function injectStyle (ssrContext) {
  __webpack_require__("IrMI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4916cf77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Foot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4916cf77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Foot_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p72H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JustDigits; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

var JustDigits = function JustDigits() {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('digitsonly', function (el, binding) {
    var numberOfComa = el.value.split('.').length - 1;
    if (/[^\d.]/g.test(el.value) === false && numberOfComa < 2) {
      console.log('ok: ' + el.value + ' , ' + numberOfComa);
    } else {
      el.value = '';
      binding.value = el.value;
    }
  });
};

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__ = __webpack_require__("RgRr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Foot_vue__ = __webpack_require__("nq5D");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      backgrounds: [{ backgroundImage: 'url(/static/background.png)' }, { backgroundImage: 'url(/static/background-2.jpg)' }, { backgroundImage: 'url(/static/background-3.jpg)' }]
    };
  },

  components: {
    Foot: __WEBPACK_IMPORTED_MODULE_1__components_Foot_vue__["a" /* default */],
    Slider: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["Slider"],
    SliderItem: __WEBPACK_IMPORTED_MODULE_0_vue_easy_slider__["SliderItem"]
  },
  mounted: function mounted() {
    document.getElementById('btn_question').style.left = '570px';
    document.getElementById('btn_question').style.right = 'unset';
  }
});

/***/ }),

/***/ "pYxc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9a0919_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("a8/K");
function injectStyle (ssrContext) {
  __webpack_require__("NLsD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a9a0919"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9a0919_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qrrU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_parts_Coloris_vue__ = __webpack_require__("ml20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_parts_FormeBordure_vue__ = __webpack_require__("EykM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_parts_TaillePlan_vue__ = __webpack_require__("yF/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_parts_TailleCredence_vue__ = __webpack_require__("JOvi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_parts_Options_vue__ = __webpack_require__("hlmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_parts_Services_vue__ = __webpack_require__("OHZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parts_Coordonnees_vue__ = __webpack_require__("RJfU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parts_Price_vue__ = __webpack_require__("2jhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parts_Tva_vue__ = __webpack_require__("PEh0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_configuration_js__ = __webpack_require__("+IK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jump_js__ = __webpack_require__("q7+D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Foot_vue__ = __webpack_require__("nq5D");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Foot: __WEBPACK_IMPORTED_MODULE_12__components_Foot_vue__["a" /* default */],
    Coloris: __WEBPACK_IMPORTED_MODULE_0__components_parts_Coloris_vue__["a" /* default */],
    TaillePlan: __WEBPACK_IMPORTED_MODULE_2__components_parts_TaillePlan_vue__["a" /* default */],
    TailleCredence: __WEBPACK_IMPORTED_MODULE_3__components_parts_TailleCredence_vue__["a" /* default */],
    FormeBordure: __WEBPACK_IMPORTED_MODULE_1__components_parts_FormeBordure_vue__["a" /* default */],
    Options: __WEBPACK_IMPORTED_MODULE_4__components_parts_Options_vue__["a" /* default */],
    Services: __WEBPACK_IMPORTED_MODULE_5__components_parts_Services_vue__["a" /* default */],
    Coordonnees: __WEBPACK_IMPORTED_MODULE_6__components_parts_Coordonnees_vue__["a" /* default */],
    Price: __WEBPACK_IMPORTED_MODULE_7__components_parts_Price_vue__["a" /* default */],
    Tva: __WEBPACK_IMPORTED_MODULE_8__components_parts_Tva_vue__["a" /* default */]
  },
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_9__assets_configuration_js__["a" /* options */],
      groups: __WEBPACK_IMPORTED_MODULE_9__assets_configuration_js__["b" /* groups */],
      services: __WEBPACK_IMPORTED_MODULE_9__assets_configuration_js__["c" /* services */],
      chants: __WEBPACK_IMPORTED_MODULE_9__assets_configuration_js__["d" /* chants */],
      color: { name: 'Abalone', src: 'abalone' },
      price: 0,
      loading: false,
      done: false
    };
  },

  watch: {
    $route: function $route() {
      if (typeof this.$route.hash !== 'undefined' && this.$route.hash !== '') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_jump_js__["a" /* default */])(this.$route.hash, { offset: -50 });
      }
    }
  },
  methods: {
    beautify: function beautify(price) {
      return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    checkEmail: function checkEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    verify: function verify() {
      var ok = true;
      var e = '';
      if (this.$store.state.devis[6].plans.length <= 0) {
        e += 'Les dimensions de votre plan de travail sont incorrectes.\n';
        ok = false;
      }
      // if (this.$store.state.devis[7].credences.length <= 0) {
      //   e += 'Les dimensions de votre crédence sont incorrectes.\n'
      //   ok = false
      // }

      if (this.$store.state.user.name === '' || this.$store.state.user.email === '' || this.$store.state.user.phone === '' || this.$store.state.user.address === '' || this.$store.state.user.city === '' || this.$store.state.user.zip === '') {
        e += 'Merci de renseigner toutes vos coordonnées\n';
        ok = false;
      } else {
        // coordonnées ok, verify email
        if (!this.checkEmail(this.$store.state.user.email)) {
          e += 'Merci de renseigner une adresse mail correcte\n';
          ok = false;
        }
      }

      if (!ok) {
        alert(e);
      }
      return ok;
    },
    download: function download() {
      var _this = this;

      // console.log(JSON.stringify(this.$store.state))
      if (this.verify()) {
        var wo = window.open('', '_blank');
        this.loading = true;
        this.generate();
        __WEBPACK_IMPORTED_MODULE_11_axios___default.a.post('http://plantravail.fr/pdf/index.php', this.$store.state).then(function (r) {
          _this.loading = false;
          _this.done = true;
          _this.response = r.data;
          wo.location.replace(r.data);
          setTimeout(function () {
            _this.done = false;
          }, 2000);
        });
      }
    },
    changeColor: function changeColor(e) {
      // console.log(e)
      this.color = e;
    },
    generate: function generate() {
      this.$store.commit('setBeautifulPrice', this.beautify(this.$store.state.price));
      // prices in store
      this.$store.commit('setDevisPrice', { id: 0, price: this.beautify(this.$store.state.devis[1].largeur * this.$store.state.devis[1].longueur * this.groups[this.$store.state.devis[0].group].credence) });
      this.$store.commit('setDevisPrice', { id: 1, price: this.beautify(this.$store.state.devis[1].largeur * this.$store.state.devis[1].longueur * this.groups[this.$store.state.devis[0].group].credence) });
      this.$store.commit('setDevisPrice', { id: 2, price: this.beautify(this.$store.state.devis[2].longueur * this.chants[this.$store.state.devis[2].chant].price) });
      this.$store.commit('setDevisPrice', { id: 3, price: this.beautify(this.$store.state.devis[3].largeur * this.$store.state.devis[3].longueur * this.groups[this.$store.state.devis[0].group].credence) });
      this.$store.commit('setDevisMultiplePrice', { id: 4,
        subid: 'options',
        price: [this.beautify(this.options[0].price * this.$store.state.devis[4].options[0].quantity), this.beautify(this.options[1].price * this.$store.state.devis[4].options[1].quantity), this.beautify(this.options[2].price * this.$store.state.devis[4].options[2].quantity), this.beautify(this.options[3].price * this.$store.state.devis[4].options[3].quantity), this.beautify(this.options[4].price * this.$store.state.devis[4].options[4].quantity), this.beautify(this.options[5].price * this.$store.state.devis[4].options[5].quantity), this.beautify(this.options[6].price * this.$store.state.devis[4].options[6].quantity), this.beautify(this.options[7].price * this.$store.state.devis[4].options[7].quantity)]
      });
      this.$store.commit('setDevisMultiplePrice', { id: 5,
        subid: 'services',
        price: [this.beautify(this.services[0].price * this.$store.state.devis[5].services[0].selected), this.beautify(this.services[1].price * this.$store.state.devis[5].services[1].selected), this.beautify(this.services[2].price * this.$store.state.devis[5].services[2].selected), this.beautify(this.services[3].price * this.$store.state.devis[5].services[3].selected), this.beautify(this.services[4].price * this.$store.state.devis[5].services[4].selected), this.beautify(this.services[5].price * this.$store.state.devis[5].services[5].selected), this.beautify(this.services[6].price * this.$store.state.devis[5].services[6].selected), this.beautify(this.services[7].price * this.$store.state.devis[5].services[7].selected)]
      });

      // names
      this.$store.commit('setDevisInfo', { id: 2, subid: 'name', val: this.chants[this.$store.state.devis[2].chant].name });
      this.$store.commit('setDevisMultipleInfo', { id: 4,
        subid: 'options',
        val: [this.options[this.$store.state.devis[4].options[0].id].name, this.options[this.$store.state.devis[4].options[1].id].name, this.options[this.$store.state.devis[4].options[2].id].name, this.options[this.$store.state.devis[4].options[3].id].name, this.options[this.$store.state.devis[4].options[4].id].name, this.options[this.$store.state.devis[4].options[5].id].name, this.options[this.$store.state.devis[4].options[6].id].name, this.options[this.$store.state.devis[4].options[7].id].name]
      });
      this.$store.commit('setDevisMultipleInfo', { id: 5,
        subid: 'services',
        val: [this.services[this.$store.state.devis[5].services[0].id].name, this.services[this.$store.state.devis[5].services[1].id].name, this.services[this.$store.state.devis[5].services[2].id].name, this.services[this.$store.state.devis[5].services[3].id].name, this.services[this.$store.state.devis[5].services[4].id].name, this.services[this.$store.state.devis[5].services[5].id].name, this.services[this.$store.state.devis[5].services[6].id].name, this.services[this.$store.state.devis[5].services[7].id].name]
      });
      this.$store.commit('setBeautifulTvaTtc');
      // console.log(this.$store.state)
      // console.log(JSON.stringify(this.$store.state))
    }
  }
});

/***/ }),

/***/ "rEkn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdf_vue__ = __webpack_require__("9DYD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e64dce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_pdf_vue__ = __webpack_require__("CFT+");
function injectStyle (ssrContext) {
  __webpack_require__("Zxut")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52e64dce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52e64dce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_pdf_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t2Vd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "x6Y0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue__ = __webpack_require__("lZ5c");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Sidebar: __WEBPACK_IMPORTED_MODULE_0__components_Sidebar_vue__["a" /* default */] },
  name: 'app'
});

/***/ }),

/***/ "xh7a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yF/B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaillePlan_vue__ = __webpack_require__("1Bpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a82b32a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TaillePlan_vue__ = __webpack_require__("IfG5");
function injectStyle (ssrContext) {
  __webpack_require__("NAvN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a82b32a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaillePlan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a82b32a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_TaillePlan_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yUn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__ = __webpack_require__("+IK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_digitsonly_js__ = __webpack_require__("p72H");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_digitsonly_js__["a" /* JustDigits */])();

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['group'],
  data: function data() {
    return {
      epaisseur: 13,
      longueur: null,
      largeur: null,
      price: 0,
      curGroup: 4,
      groups: __WEBPACK_IMPORTED_MODULE_0__assets_configuration_js__["b" /* groups */],
      credences: []
    };
  },

  watch: {
    group: function group() {
      if (this.$store.state.devis[0].group !== this.curGroup) {
        this.setPrice();
        this.curGroup = this.$store.state.devis[0].group;
      }
    }
  },
  methods: {
    addCredence: function addCredence() {
      if (this.longueur != null && this.largeur != null && !isNaN(this.longueur) && !isNaN(this.largeur)) {
        var p = this.longueur * this.largeur * this.groups[this.$store.state.devis[0].group].credence;
        this.credences.push({ lng: this.longueur, lrg: this.largeur, price: p, beautifulPrice: this.beautify(p) });
        this.longueur = null;
        this.largeur = null;
        this.$store.commit('addPrice', p);
        this.setDevis();
      }
    },
    removeCredence: function removeCredence(_index) {
      this.$store.commit('subPrice', this.credences[_index].price);
      this.credences.splice(_index, 1);
      this.setDevis();
    },
    setDevis: function setDevis() {
      this.$store.commit('setDynamicDevis', { id: 7, set: { credences: this.credences } });
    },
    beautify: function beautify(price) {
      return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9a7415584e9b7755a961.js